<template>

  <modalo
    :title="scoreform.name"
    type="medium"
    @hideModal="hideModal()"
    :modaloWatch="() => scoreform">

    <div
      v-if="page === 'options'"
      class="list-group">
      <a
        href="javascript:void(0)"
        class="list-group-item list-group-item-action"
        v-for="option in options"
        :key="option.value"
        @click="goto(option.value)">
        <div class="d-flex w-100 justify-content-between">
          <h5 class="mb-1">{{ option.label }}</h5>
        </div>
        <p class="mb-1">{{ option.description }}</p>
      </a>
    </div>

    <JobProfileScoreformsOptionsTemplate
      v-if="page === 'template'"
      :jobId="jobId"
      @input="setTemplate"
      @back="page = 'options'" />

    <JobProfileScoreformsOptionsIA
      v-if="page === 'ia'"
      :jobId="jobId"
      @input="setTemplate"
      @back="page = 'options'" />

    <form
      v-if="page === 'form'"
      id="scoreform-form"
      v-on:submit.prevent="saveScoreform(scoreform)">
      <ScoreformForm
        :initScoreform="scoreform"
        :validateErrors="validateErrors"
        @update="scoreform=$event" />
    </form>

    <template slot="footer">
      <div :class="{'box-loading': loading}">
        <button
          v-if="page === 'form'"
          type="submit"
          form="scoreform-form"
          class="btn btn-primary">{{ $t('Save') }}</button>
        <button
          type="button"
          class="btn btn-light"
          @click="hideModal()">{{ $t('Cancel') }}</button>
        <button
          v-if="page === 'form' && scoreform._id"
          type="button"
          class="btn btn-danger"
          @click="deleteScoreform(scoreform._id)">{{ $t('Delete') }}</button>
      </div>
    </template>

  </modalo>

</template>

<script>
import JobProfileScoreformsOptionsTemplate from './JobProfileScoreformsOptionsTemplate.vue'
import JobProfileScoreformsOptionsIA from './JobProfileScoreformsOptionsIA.vue'
import ScoreformForm from '@/components/Scoreform/ScoreformForm.vue'
export default {
  name: 'JobProfileScoreformsModalForm',
  components: {
    JobProfileScoreformsOptionsTemplate,
    JobProfileScoreformsOptionsIA,
    ScoreformForm
  },
  props: {
    jobId: {
      type: String,
      required: true
    },
    initScoreform: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      page: this.initScoreform && this.initScoreform._id ? 'form' : 'options',
      loading: false,
      scoreform: this.defaultValues(this.initScoreform),
      validateErrors: {},
      options: [{
        label: this.$t('Create with AI'),
        description: this.$t('Use artificial intelligence to generate a scorecard template.'),
        value: 'ia'
      }, {
        label: this.$t('Combine templates'),
        description: this.$t('Use global templates to create a new scorecard.'),
        value: 'template'
      }, {
        label: this.$t('Create from scratch'),
        description: this.$t('Create a scorecard from scratch.'),
        value: 'blank'
      }]
    }
  },
  created () {
  },
  methods: {
    /*
    defaultValues
    */
    defaultValues (values) {
      return values._id
      ? this.$clone(values)
      : Object.assign({
        'groups': []
      }, values)
    },
    addGroup () {
      this.scoreform.groups.push({
        'name': '',
        'questions': ['']
      })
    },
    removeGroup (index) {
      this.scoreform.groups.splice(index, 1)
    },
    addQuestion (items) {
      items.push('')
    },
    removeQuestion (items, index) {
      items.splice(index, 1)
    },
    /* hideModal  */
    hideModal () {
      this.$emit('hideModal')
    },
    /*
    saveScoreform
    */
    saveScoreform (data) {
      if (data._id) this.updateScoreform(data)
      else this.createScoreform({ ...data, job_id: this.jobId })
    },
    /*
    createScoreform
    */
    createScoreform (data) {
      this.loading = true

      this.$store
      .dispatch('createJobScoreform', {
        ...data,
        job_id: this.jobId
      })
      .then((result) => {
        this.loading = false
        this.$emit('saved')
      })
      .catch((err) => {
        this.loading = false
        if (err.response.data.name === 'ValidationError') {
          this.validateErrors = err.response.data.errors
        }
      })
    },
    /*
    updateScoreform
    */
    updateScoreform (data) {
      this.loading = true

      this.$store
      .dispatch('updateJobScoreform', {
        job_id: this.jobId,
        ...data
      })
      .then(() => {
        this.loading = false
        this.$emit('saved')
      })
      .catch((err) => {
        this.loading = false
        if (err.response.data.name === 'ValidationError') {
          this.validateErrors = err.response.data.errors
        }
      })
    },
    /*
    delete
    */
    deleteScoreform (id) {
      const deleteAction = () => {
        this.loading = true

        this.$store
        .dispatch('deleteJobScoreform', {
          job_id: this.jobId,
          id: id
        })
        .then((result) => {
          this.loading = false
          this.$emit('saved')
        })
      }

      this.$store
      .dispatch('setAlertModal', {
        action: deleteAction
      })
    },
    setTemplate (template) {
      this.scoreform = template
      this.page = 'form'
    },
    goto (page) {
      if (page === 'ia') {
        this.page = 'ia'
      } else if (page === 'template') {
        this.page = 'template'
      } else if (page === 'blank') {
        this.scoreform = {
          name: '',
          groups: [{
            name: '',
            questions: ['']
          }]
        }
        this.page = 'form'
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Job/JobProfile/JobProfileScoreformsModalForm.vue